import { render, staticRenderFns } from "./JudgingCriteriaList.vue?vue&type=template&id=37e647b8&scoped=true"
import script from "./JudgingCriteriaList.vue?vue&type=script&lang=js"
export * from "./JudgingCriteriaList.vue?vue&type=script&lang=js"
import style0 from "./JudgingCriteriaList.vue?vue&type=style&index=0&id=37e647b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e647b8",
  null
  
)

export default component.exports